export default __webpack_public_path__ + "static/media/testimonials-2.4b41e5c0.jpg";